import { ThemeProvider as FluentThemeProvider } from '@fluentui/react/lib/Theme';
import React, { FC } from 'react';

import { ThemeProviderProps } from './ThemeProvider.types';

const ThemeProvider: FC<ThemeProviderProps> = (props) => <FluentThemeProvider {...props} applyTo="none" />;

export default ThemeProvider;
